import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';

import { MDM_TYPES } from '@/constants/mdm';
import { useFeedsStore, useSourcesStore } from '@/stores';
import { SourceMdm } from '@/types/sources';

import useAuth from './useAuth';

export function usePreferredCRMFeed() {
  const feedsStore = useFeedsStore();
  const { crmFeeds } = storeToRefs(feedsStore);
  const sourcesStore = useSourcesStore();
  const { preferredCRMFeedId } = useAuth();

  const preferredCRMFeed = computed(() => {
    if (crmFeeds.value.length === 0) {
      return null;
    }
    if (!preferredCRMFeedId.value) {
      return crmFeeds.value[0];
    }
    return crmFeeds.value.find((f) => f.id === preferredCRMFeedId.value);
  });

  function getSourceByMdm(mdmType: SourceMdm) {
    const feedId = preferredCRMFeed.value?.id;
    if (feedId === undefined) return undefined;
    return sourcesStore.getSourceByFeedIdAndMdmType(feedId, mdmType);
  }
  const preferredCRMFeedSource = computed(() => {
    if (!preferredCRMFeed.value) return null;
    return getSourceByMdm(MDM_TYPES.ACCOUNT);
  });

  onMounted(async () => {
    await Promise.all([feedsStore.readySync, sourcesStore.readySync]);
  });

  return {
    preferredCRMFeed,
    preferredCRMFeedSource,
    getSourceByMdm,
  };
}
